/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Tab_Timing_SyncInputs */

const en_quicktools_tab_timing_sync = /** @type {(inputs: Quicktools_Tab_Timing_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing & Sync`)
};

const fr_quicktools_tab_timing_sync = /** @type {(inputs: Quicktools_Tab_Timing_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutage et synchronisation`)
};

const de_quicktools_tab_timing_sync = /** @type {(inputs: Quicktools_Tab_Timing_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing & Synchronisation`)
};

const it_quicktools_tab_timing_sync = /** @type {(inputs: Quicktools_Tab_Timing_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempistica e sincronizzazione`)
};

const ru_quicktools_tab_timing_sync = /** @type {(inputs: Quicktools_Tab_Timing_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синхронизация и определение времени`)
};

const es_quicktools_tab_timing_sync = /** @type {(inputs: Quicktools_Tab_Timing_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronización y tiempo`)
};

const zh_cn2_quicktools_tab_timing_sync = /** @type {(inputs: Quicktools_Tab_Timing_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时序与同步`)
};

const ja_quicktools_tab_timing_sync = /** @type {(inputs: Quicktools_Tab_Timing_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイミングと同期`)
};

const hi_quicktools_tab_timing_sync = /** @type {(inputs: Quicktools_Tab_Timing_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय और सिंक्रनाइज़ेशन`)
};

const pt_pt2_quicktools_tab_timing_sync = /** @type {(inputs: Quicktools_Tab_Timing_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronização e ajuste de tempo`)
};

/**
* | output |
* | --- |
* | "Timing & Sync" |
*
* @param {Quicktools_Tab_Timing_SyncInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_tab_timing_sync = /** @type {((inputs?: Quicktools_Tab_Timing_SyncInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Tab_Timing_SyncInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_quicktools_tab_timing_sync(inputs)
	if (locale === "de") return de_quicktools_tab_timing_sync(inputs)
	if (locale === "it") return it_quicktools_tab_timing_sync(inputs)
	if (locale === "ru") return ru_quicktools_tab_timing_sync(inputs)
	if (locale === "es") return es_quicktools_tab_timing_sync(inputs)
	if (locale === "zh-CN") return zh_cn2_quicktools_tab_timing_sync(inputs)
	if (locale === "ja") return ja_quicktools_tab_timing_sync(inputs)
	if (locale === "hi") return hi_quicktools_tab_timing_sync(inputs)
	if (locale === "pt-PT") return pt_pt2_quicktools_tab_timing_sync(inputs)
	return en_quicktools_tab_timing_sync(inputs)
});